var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contacts",
    d: "M13.657,26.848a11.493,11.493,0,0,0,4.632-.945,12.3,12.3,0,0,0,6.423-6.423,11.876,11.876,0,0,0-.006-9.27,12.371,12.371,0,0,0-2.6-3.835A12.071,12.071,0,0,0,18.276,3.78a11.624,11.624,0,0,0-4.632-.933,11.58,11.58,0,0,0-4.626.933,12.268,12.268,0,0,0-6.429,6.429A11.876,11.876,0,0,0,2.6,19.48,12.36,12.36,0,0,0,9.018,25.9,11.48,11.48,0,0,0,13.657,26.848Zm-.012-1.878a9.93,9.93,0,0,1-2.631-.358,10.619,10.619,0,0,1-2.477-1.025,8.952,8.952,0,0,1-2.069-1.618A5.93,5.93,0,0,1,8.2,20.258a8.525,8.525,0,0,1,2.47-1.087,11.313,11.313,0,0,1,2.971-.377,11.37,11.37,0,0,1,2.952.371,8.5,8.5,0,0,1,2.47,1.081,5.843,5.843,0,0,1,1.742,1.723,8.714,8.714,0,0,1-2.057,1.618,10.619,10.619,0,0,1-2.477,1.025A9.93,9.93,0,0,1,13.644,24.97Zm0-8.165a3.794,3.794,0,0,1-2.05-.6,4.232,4.232,0,0,1-1.451-1.581,4.691,4.691,0,0,1-.537-2.267,4.477,4.477,0,0,1,.537-2.174A4.276,4.276,0,0,1,11.6,8.6a3.81,3.81,0,0,1,4.082,0,4.346,4.346,0,0,1,1.458,1.581,4.436,4.436,0,0,1,.543,2.174,4.764,4.764,0,0,1-.537,2.279,4.207,4.207,0,0,1-1.451,1.593A3.639,3.639,0,0,1,13.644,16.805Z",
    transform: "translate(-1.65 -2.848)",
    fill: "#636974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.f1375781ecce02159ed50571a9282535.svg";
export { ForwardRef as ReactComponent };